/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateCompetitionBodyOnboardingSectionGetStartedStepsInner
 */
export interface CreateCompetitionBodyOnboardingSectionGetStartedStepsInner {
    /**
     * 
     * @type {string}
     * @memberof CreateCompetitionBodyOnboardingSectionGetStartedStepsInner
     */
    header?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompetitionBodyOnboardingSectionGetStartedStepsInner
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompetitionBodyOnboardingSectionGetStartedStepsInner
     */
    icon?: string;
}

/**
 * Check if a given object implements the CreateCompetitionBodyOnboardingSectionGetStartedStepsInner interface.
 */
export function instanceOfCreateCompetitionBodyOnboardingSectionGetStartedStepsInner(value: object): value is CreateCompetitionBodyOnboardingSectionGetStartedStepsInner {
    return true;
}

export function CreateCompetitionBodyOnboardingSectionGetStartedStepsInnerFromJSON(json: any): CreateCompetitionBodyOnboardingSectionGetStartedStepsInner {
    return CreateCompetitionBodyOnboardingSectionGetStartedStepsInnerFromJSONTyped(json, false);
}

export function CreateCompetitionBodyOnboardingSectionGetStartedStepsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCompetitionBodyOnboardingSectionGetStartedStepsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'header': json['header'] == null ? undefined : json['header'],
        'description': json['description'] == null ? undefined : json['description'],
        'icon': json['icon'] == null ? undefined : json['icon'],
    };
}

export function CreateCompetitionBodyOnboardingSectionGetStartedStepsInnerToJSON(json: any): CreateCompetitionBodyOnboardingSectionGetStartedStepsInner {
    return CreateCompetitionBodyOnboardingSectionGetStartedStepsInnerToJSONTyped(json, false);
}

export function CreateCompetitionBodyOnboardingSectionGetStartedStepsInnerToJSONTyped(value?: CreateCompetitionBodyOnboardingSectionGetStartedStepsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'header': value['header'],
        'description': value['description'],
        'icon': value['icon'],
    };
}

